import React, { Component } from 'react';

class Snippet extends Component {
  constructor(props) {
    super(props);
    this.state = { page: 0 };
  }

  render() {
    const { part } = this.props;
    const snippets = Array.isArray(part.attachment) ? part.attachment : [part.attachment];
    const { page } = this.state;
    const setTags = (str) => str.replace(/\[HIGHLIGHT\]/g, '<span class="highlight">').replace(/\[\/HIGHLIGHT\]/g, '</span>');

    return (
      <div className="attachment-matches-wrapper">
        <p>
          <img src="/sites/all/modules/custom/ir_search/css/images/pdficon.png" alt=""/>
          <a href="#" className="preview-matches">
            {` Preview ${snippets.length} ${snippets.length === 1 ? 'match' : ' matches'}
               within document part ${part.part_number} ${part.part_description}`}
          </a>
        </p>
        <div className="attachment-matches">
          <div dangerouslySetInnerHTML={{ __html: setTags(snippets[page]) }} />
          <p className="attachment-pager">
            <a href="#" onClick={e => {
              e.preventDefault();
              this.setState({ page: page === 0 ? page : (page - 1) });
            }}>
              «
            </a>
            Result {page + 1}/{snippets.length}
            <a href="#" onClick={e => {
              e.preventDefault();
              this.setState({ page: page === snippets.length - 1 ? page : (page + 1) });
            }}>
              »
            </a>
          </p>
        </div>
      </div>
    );
  }
}

export default Snippet;


// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/Snippet.jsx